import {
  Box,
  BoxProps,
  SizableText,
  Stack,
  StackProps,
  XStack,
  isWeb,
  shadowStandard,
  shadowSmall
} from '@my/ui'
import { Pencil } from '@tamagui/lucide-icons'
import { UserAvatar } from 'app/features/user/components'
import { User } from 'app/types'

type CreatePostButton = {
  user?: Pick<User, 'fullName' | 'avatar'> | null
  onPress: () => void
}

export const CreatePostButton = ({ user, onPress, ...props }: CreatePostButton & BoxProps) => {
  if (!user) return null
  return (
    <XStack ai='center' br="$3" p="$2" bg="$white" $gtSm={{ p: '$3.5' }} gap="$3.5" {...shadowStandard} {...props}>
      <UserAvatar src={user.avatar?.small} alt="" width={44} height={44} />
      <Box boc="$overlay3" h={56} bw={1} flex={1} onPress={onPress} shadow={false} {...shadowSmall} pressable>
        <SizableText color="$gray11" size="$4" fow="500"> 
          What’s on your mind, {user.fullName}?
        </SizableText>
      </Box>
    </XStack>
  )
}

type FloatingCreatePostButtonProps = {
  onPress: () => void
}

export const FloatingCreatePostButton = ({
  onPress,
  ...props
}: FloatingCreatePostButtonProps & StackProps) => {
  return (
    <Stack
      onPress={onPress}
      tag="button"
      cursor="pointer"
      pos={isWeb ? ('fixed' as 'absolute') : 'absolute'}
      w={64}
      h={64}
      bottom="$3.5"
      right="$3"
      bg="$white"
      br={1000}
      bw={0}
      jc="center"
      ai="center"
      zIndex="$5"
      animation="quick"
      hoverStyle={{
        scale: 1.08,
        opacity: 0.8,
      }}
      focusStyle={{
        scale: 1.08,
        opacity: 0.75,
      }}
      pressStyle={{
        scale: 1.02,
        opacity: 0.9,
      }}
      {...shadowStandard}
      {...props}
    >
      <Stack w={58} h={58} br={1000} jc="center" ai="center" bg="$primary" p="$2">
        <Pencil size={24} />
      </Stack>
    </Stack>
  )
}
